/*
 * @Email: liuyi01@new4g.cn
 * @FilePath: /cbibank-web-corporbank/src/views/outward/api/inner.js
 * @Date: 2021-12-21 16:18:16
 * @Author: LiuYi
 * @LastEditTime: 2021-12-21 16:18:16
 */

import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

export default {
  /**
    * 获取账户余额
    * @param {string} accountNo
    * @param {string} currentBusinessCode 写死10100000
    */
  getAccountBalance (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/accountBalanceQuery.do`, params, config, 'URLEncoded')
  },

  /**
    * 查询账号信息
    * @param {string} accountNo
    * @param {string} currentBusinessCode 写死10200000
    */
  getAccountInfo (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/queryAccountName.do`, params, config, 'URLEncoded')
  },

  /**
    * 查询单笔限额
    * @param {string} accountNo
    * @param {string} recAccount
    */
  getAccountTransLimit (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/transfer/acct/limit/tran`, params, config, 'URLEncoded')
  },

  /**
    * 查询转账手续费
    * @param {string} recBankType
    * @param {string} currentBusinessCode
    * @param {string} systemCode
    * @param {string} payAmount
    * @param {string} payAccount
    * @param {string} channel
    * @param {string} feeType
    * @param {string} currencyType
    */
  queryChargeFee (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/queryChargeFee.do`, params, config, 'URLEncoded')
  },

  /**
    * 查询收款账户
    * @param {string} recAccount
    * @param {string} currentBusinessCode
    */
  checkUserAcc (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/checkUserAcc.do`, params, config, 'URLEncoded')
  },

  /**
    * 查询是否符合MSB规则
    * @param {string} ownAcc
    * @param {string} otherAcc
    */
  checkMsbAccount (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/msb/payment/canTransfer`, params, config, 'URLEncoded')
  },

  /**
    * 限额校验
    * @param {string} payAccount 付款帐号
    * @param {string} payAmount 付款金额
    * @param {string} recAccount 收款帐号
    * @param {string} currencyType 币种
    * @param {string} currentBusinessCode
  */
  accLimitQueryGRB (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/accLimitQueryGRB.do`, params, config, 'URLEncoded')
  },

  /**
    * 发起交易
    * @param {string} recBankType 转账渠道
    * @param {string} recAccountName 收款人户名
    * @param {string} recAccount 收款帐号
    * @param {string} currentBusinessCode
    * @param {string} commonPayee
    * @param {string} tranChannel
  */
  addCustomerPayee (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/addCustomerPayee.do`, params, config, 'URLEncoded')
  },

  /**
  * 用户验签，发起交易
  * @param {string} payAccount
  * @param {string} recAccountName
  * @param {string} payAccountAliasName
  * @param {string} currencyType
  * @param {string} balanceAvailable
  * @param {string} recAccount
  * @param {string} recAccountName
  * @param {string} addPayBookFlag
  * @param {string} payAmount
  * @param {string} chargeFee
  * @param {string} payUse
  * @param {string} logRecordFlag
  * @param {string} recBankType  转账渠道 0
  * @param {string} rmtType 加急标识 3
  * @param {string} transferChannel
  * @param {string} businessCode
  * @param {string} currentBusinessCode
  * @param {string} transferName
  * @param {string} channel
  */
  submitInnerTransferConfirm (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/submitInnerTransfer_confirm.do`, params, config, 'URLEncoded')
  }
}
